export const onInputChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  property: string,
  setObject: (object: any) => void
) => {
  const val = e.target.value
  setObject((prevCamera: any) => ({
    ...prevCamera,
    [property]: val,
  }))
}
